(() => {
  const leadInputs = Array.from(document.querySelectorAll('[data-br-lead-tags]'));
  const popup = document.querySelector('[data-br-lead-popup]');
  if (!popup && !leadInputs.length) return;

  const attributionKey = 'br_lead_attribution_v1';

  const storage = {
    get(key, session) {
      try {
        return (session ? window.sessionStorage : window.localStorage).getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value, session) {
      try {
        (session ? window.sessionStorage : window.localStorage).setItem(key, value);
      } catch (error) {
        return;
      }
    }
  };

  function cleanTag(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 42);
  }

  function captureAttribution() {
    const now = Date.now();
    let saved = null;

    try {
      saved = JSON.parse(storage.get(attributionKey) || 'null');
    } catch (error) {
      saved = null;
    }

    if (saved && saved.capturedAt && now - saved.capturedAt < 30 * 86400000) return saved;

    const params = new URLSearchParams(window.location.search);
    const attribution = {
      source: cleanTag(params.get('utm_source')),
      medium: cleanTag(params.get('utm_medium')),
      campaign: cleanTag(params.get('utm_campaign')),
      referrer: '',
      capturedAt: now
    };

    if (!attribution.source && document.referrer) {
      try {
        const referrerHost = new URL(document.referrer).hostname.replace(/^www\./, '');
        const currentHost = window.location.hostname.replace(/^www\./, '');
        if (referrerHost && referrerHost !== currentHost) attribution.referrer = cleanTag(referrerHost);
      } catch (error) {
        attribution.referrer = '';
      }
    }

    if (!attribution.source && !attribution.referrer) attribution.referrer = 'direct';
    storage.set(attributionKey, JSON.stringify(attribution));
    return attribution;
  }

  const attribution = captureAttribution();

  function updateLeadTags(input, extraTags) {
    if (!input) return;
    const tags = input.value.split(',').map((tag) => tag.trim()).filter(Boolean);
    (extraTags || []).filter(Boolean).forEach((tag) => tags.push(tag));
    if (attribution.source) tags.push('br-utm-source-' + attribution.source);
    if (attribution.medium) tags.push('br-utm-medium-' + attribution.medium);
    if (attribution.campaign) tags.push('br-utm-campaign-' + attribution.campaign);
    if (attribution.referrer) tags.push('br-referrer-' + attribution.referrer);
    input.value = Array.from(new Set(tags)).join(',');
  }

  leadInputs.forEach((input) => {
    const leadForm = input.closest('form');
    updateLeadTags(input);
    if (leadForm) leadForm.addEventListener('submit', () => updateLeadTags(input));
  });

  if (!popup) return;

  const panel = popup.querySelector('.br-lead-popup__panel');
  const form = popup.closest('form');
  const email = popup.querySelector('input[type="email"]');
  const tagsInput = popup.querySelector('[data-br-lead-tags]');
  const closeButtons = popup.querySelectorAll('[data-br-popup-close]');
  const success = popup.dataset.success === 'true';
  const formForceOpen = popup.dataset.forceOpen === 'true';
  const previewForceOpen = new URLSearchParams(window.location.search).get('br_popup') === '1';
  const forceOpen = formForceOpen || previewForceOpen;
  const delay = Math.max(0, Number(popup.dataset.delayMs) || 10000);
  const scrollThreshold = Math.min(0.95, Math.max(0.1, Number(popup.dataset.scrollThreshold) || 0.4));
  const frequencyDays = Math.max(1, Number(popup.dataset.frequencyDays) || 14);
  const dismissedKey = 'br_lead_popup_dismissed_at_v1';
  const subscribedKey = 'br_lead_popup_subscribed_v1';
  const sessionKey = 'br_lead_popup_opened_v1';
  let isOpen = false;
  let armed = false;
  let previousFocus = null;
  let timer = null;

  function focusableElements() {
    return Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((element) => !element.hasAttribute('hidden'));
  }

  function openPopup(trigger) {
    if (isOpen) return;
    popup.dataset.trigger = trigger || 'forced';
    updateLeadTags(tagsInput, ['br-trigger-' + cleanTag(popup.dataset.trigger)]);
    previousFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('br-lead-popup-open');
    storage.set(sessionKey, '1', true);
    window.requestAnimationFrame(() => {
      popup.classList.add('is-open');
      (email || panel).focus({ preventScroll: true });
    });
    isOpen = true;
    removeTriggers();
  }

  function closePopup() {
    if (!isOpen) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('br-lead-popup-open');
    storage.set(dismissedKey, String(Date.now()));
    window.setTimeout(() => {
      popup.hidden = true;
    }, 230);
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
    isOpen = false;
  }

  function onScroll() {
    if (!armed || isOpen) return;
    const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    const progress = (window.scrollY + window.innerHeight) / Math.max(documentHeight, 1);
    if (progress >= scrollThreshold) openPopup('scroll');
  }

  function onMouseLeave(event) {
    if (armed && event.clientY <= 0 && window.matchMedia('(pointer: fine)').matches) openPopup('exit');
  }

  function onKeyDown(event) {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      closePopup();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusables = focusableElements();
    if (!focusables.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function removeTriggers() {
    if (timer) window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.documentElement.removeEventListener('mouseleave', onMouseLeave);
  }

  if (success) storage.set(subscribedKey, '1');

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  document.addEventListener('keydown', onKeyDown);
  if (form) form.addEventListener('submit', () => updateLeadTags(tagsInput, ['br-trigger-' + cleanTag(popup.dataset.trigger)]));

  if (forceOpen) {
    openPopup(success ? 'success' : formForceOpen ? 'error' : 'preview');
    return;
  }

  const subscribed = storage.get(subscribedKey) === '1';
  const openedThisSession = storage.get(sessionKey, true) === '1';
  const dismissedAt = Number(storage.get(dismissedKey) || 0);
  const dismissedRecently = dismissedAt > 0 && Date.now() - dismissedAt < frequencyDays * 86400000;
  const inThemeEditor = window.Shopify && window.Shopify.designMode;

  if (subscribed || openedThisSession || dismissedRecently || inThemeEditor) return;

  window.setTimeout(() => {
    armed = true;
  }, 2500);

  timer = window.setTimeout(() => openPopup('delay'), delay);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.documentElement.addEventListener('mouseleave', onMouseLeave);
})();